import FooterMenuItem from './FooterMenuItem';

export default FooterMenuItem;
